var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a-tag',{staticClass:"is_tag",attrs:{"color":_vm.instance.list[_vm.scope.scope.status].color}},[_vm._v(" "+_vm._s(_vm.scope.scope.statusStr)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }